'use strict';
import angular from 'angular';

angular.module('buySheetConfig.services', [])
    .factory('BuySheetConfigService', BuySheetConfigService)
    .factory('BuySheetConfigFactory', BuySheetConfigFactory)
    .factory('SignaturesFactory', SignaturesFactory)

/**
 * @ngInject
 */
function BuySheetConfigService(BuySheetConfigFactory, SignaturesFactory) {
    return {
        orderFields(id) {
            return BuySheetConfigFactory.buySheetConfig().orderFields({id: id}).$promise
        },
        productFields(id) {
            return BuySheetConfigFactory.buySheetConfig().productFields({id: id}).$promise
        },
        clientFields(id) {
            return BuySheetConfigFactory.buySheetConfig().clientFields({id: id}).$promise
        },
        flightFields(id) {
            return BuySheetConfigFactory.buySheetConfig().flightFields({id: id}).$promise
        },
        getBuySheetTemplates() {
            return BuySheetConfigFactory.buySheetConfig().index().$promise;
        },
        getBuySheetTemplate(id) {
            return BuySheetConfigFactory.buySheetConfig().show({id: id}).$promise;
        },
        createBuySheetTemplate(template) {
            return BuySheetConfigFactory.buySheetConfig().create({buy_sheet_template: template}).$promise
        },
        updateBuySheetTemplate(id, template) {
            return BuySheetConfigFactory.buySheetConfig().update({id: id, buy_sheet_template: template}).$promise
        },
        deleteSignature(id) {
            return SignaturesFactory.signatures().delete({id: id}).$promise
        }
    };
}

/**
 * @ngInject
 */
function BuySheetConfigFactory($resource, AppConfig) {
    return {
        buySheetConfig() {
            let url = AppConfig.IO_API_URL + 'buySheetTemplates';
            return $resource(url, null, {
                clientFields: {
                    method: 'GET',
                    isArray: false,
                    url: url + '/clientFields'
                },
                orderFields: {
                    method: 'GET',
                    isArray: false,
                    url: url + '/orderFields'
                },
                productFields: {
                    method: 'GET',
                    isArray: false,
                    url: url + '/productFields'
                },
                flightFields: {
                    method: 'GET',
                    isArray: false,
                    url: url + '/flightFields'
                },
                index: {
                    method: 'GET',
                    isArray: false,
                    url: url
                },
                create: {
                    method: 'POST',
                    isArray: false,
                    url: url + '/create'
                },
                show: {
                    method: 'GET',
                    isArray: false,
                    url: url + '/show'
                },
                update: {
                    method: 'PUT',
                    isArray: false,
                    url: url + '/update'
                }
            })
        }
    }
}

/**
 * @ngInject
 */
function SignaturesFactory($resource, AppConfig) {
    return {
        signatures() {
            return $resource(AppConfig.IO_API_URL + 'signatures', null, {
                delete: {
                    method: 'DELETE',
                    isArray: false
                }
            })
        }
    }
}